export const FOOTER_NAV = [
  {
    title: 'about',
    href_en: 'https://ittihadclub.sa/en/about',
    href_ar: 'https://ittihadclub.sa/ar/about',
    external: true,
  },
  {
    title: 'store',
    href_en: 'https://shop.ittihadclub.sa/en',
    href_ar: 'https://shop.ittihadclub.sa',
    external: true,
  },
];

export const FOOTER_SUB_NAV = [
  {
    name: 'cookie_policy',
    href_en: '#',
    href_ar: '#',
  },
  {
    name: 'terms_and_conditions',
    href_en: '#',
    href_ar: '#',
  },
  {
    name: 'privacy_policy',
    href_en: '#',
    href_ar: '#',
  },
];
